import hasWhitespacesOnly from "./common/hasWhitespacesOnly";
import incorrectDataType from "./common/incorrectDataType";
import isEmpty from "./common/isEmpty";
import isNull from "./common/isNull";
import isUndefined from "./common/isUndefined";

export const isValidNumber = (number, length = 1) => {
	if (
		isNull(number) ||
		isUndefined(number) ||
		incorrectDataType(number, "string") ||
		hasWhitespacesOnly(number) ||
		isEmpty(number)
	) {
		return false;
	} else {
        const regex_number = new RegExp(`^[0-9]{${length},}$`);
		return regex_number.test(number);
	}
};
